import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BoxComponent, HeadingComponent, IconComponent } from '@recruitee/user-interface';

import { Destroyable } from '../../../common';
import { DynamicHelpers } from '../../helpers';
import type { DynamicText } from '../../types';
import { DynamicInputConfigType, DynamicListInfoConfig } from '../../types';

export class DynamicListInfo {
  public readonly kind = <const>'DynamicListInfo';
  public type: DynamicListInfoConfig['type'] = DynamicInputConfigType.LIST_INFO;

  constructor(public config: DynamicListInfoConfig) {}
}

@Component({
  selector: 'rti-dynamic-list-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: `./dynamic-list-info.component.html`,
  styleUrls: ['./dynamic-list-info.component.less'],
  imports: [IconComponent, BoxComponent, HeadingComponent],
})
@Destroyable()
export class DynamicListInfoComponent {
  @Input() public input: DynamicListInfo;

  constructor(private helpers: DynamicHelpers) {}

  public get header(): string | null {
    if (this.input.config.header) {
      return this.buildText(this.input.config.header);
    } else {
      return null;
    }
  }

  public get items(): DynamicText[] {
    return this.input.config.items;
  }

  public get itemsVisible(): boolean {
    return this.items.length > 0;
  }

  public trackByItem(index: number, _item: DynamicText): number {
    return index;
  }

  public buildText(text: DynamicText): string {
    return this.helpers.buildText(text);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@angular-eslint/no-empty-lifecycle-method
  public ngOnInit(): void {}
}
